export const GAIA_SERVICE_IDENTITY = "urn:cdo:FinTech-Tax-Gaia:AWS:Default";

export const isGaiaServiceIdentity = (
  user: string | undefined | null,
): boolean => user === GAIA_SERVICE_IDENTITY;

export const isValidGaiaIdentity = (gaiaObjectId: string) => {
  return (
    gaiaObjectId.match(
      /^(audit|notice|litigation)[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[A-Z]\d{7}$/,
    ) !== null
  );
};

export const isValidBrazilCpf = (id: string | undefined) => {
  return id && id.match(/^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/) !== null;
};

export const isValidBrazilCnpj = (id: string | undefined) => {
  return id && id.match(/^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/) !== null;
};

export const hasMoreThanTenIds = (_data: string | undefined) => {
  throw new Error("Function not implemented.");
};

export const validateField = (
  value: string,
  fieldName: string,
  maxLength: number,
  invalidChars: RegExp,
) => {
  if (!value.trim()) {
    return `${fieldName} is required`;
  }
  if (value.length > maxLength) {
    return `${fieldName} cannot exceed ${maxLength} characters`;
  }

  if (invalidChars.test(value)) {
    return `${fieldName} contains invalid characters`;
  }
  return "";
};

// CSV Formula Injection Prevention - addresses CWE-1236
const FORMULA_INJECTION_CHARS = new Set([
  "=",
  "+",
  "-",
  "@",
  "*",
  "/",
  "^",
  "|",
  "\t",
  "\r",
]);

export function sanitizeForCSV(value: any): any {
  if (typeof value !== "string") {
    return value;
  }
  if (value.length === 0) {
    return value;
  }

  let sanitized = value;

  // Replace problematic characters that break CSV structure
  sanitized = sanitized.replace(/[\r\n\u2028\u2029\t]/g, " "); // Line breaks and tabs → spaces

  // Remove other control characters (ASCII 0-31 except space)
  sanitized = sanitized.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, "");

  // Escape internal quotes by doubling them for proper CSV format
  sanitized = sanitized.replace(/"/g, '""');

  // Trim excessive whitespace
  sanitized = sanitized.replace(/\s+/g, " ").trim();

  // Check for formula injection AFTER cleaning
  const firstChar = sanitized.charAt(0);
  if (FORMULA_INJECTION_CHARS.has(firstChar)) {
    sanitized = `'${sanitized}`;
  }

  return sanitized;
}
